/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum LoginStatus {
  CROSS = "CROSS",
  INVALID_CRED = "INVALID_CRED",
  NOT_VERIFIED = "NOT_VERIFIED",
  SUCCESS = "SUCCESS",
}